import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import logo from "../../assets/images/synergy/synergy_logo.jpg";

function Footer() {
    return (
        <footer className="footer p-10 bg-base-200 text-base-content">
            <div>
                <img src={logo} alt="logo" width={66} height={56} />
                <h1 className="text-xl">Myanmar Synergy<br/>Garment</h1>
            </div>
            <div>
                <span className="footer-title">Factory Process</span>
                <p>Warehouse</p>
                <p>Pattern Room</p>
                <p>Cutting</p>
                <p>Sewing</p>
                <p>Finishing</p>
            </div>
            <div>
                <span className="footer-title">Company</span>
                <Link to={paths.about}><p>About us</p></Link>
                <Link to={paths.contact}><p>Contact us</p></Link>
                <p className="pt-4">Copyright © {(new Date().getFullYear())} - All right reserved by Myanmar Synergy Garment.</p>
            </div>
        </footer>
    );
}

export default Footer;